// Similar with the NodeJS's path.basename, but it supports .* like Ruby's File.basename.
export const basename = (path: string, ext?: string) => {
  const components = path.split("/");
  const base = components[components.length - 1];

  if (ext && (ext === ".*" || base.endsWith(ext))) {
    return base.split(".").slice(0, -1).join(".");
  }
  return base;
};
